import { render, staticRenderFns } from "./ChangedPrices.vue?vue&type=template&id=720995ee&scoped=true"
import script from "./ChangedPrices.vue?vue&type=script&lang=ts"
export * from "./ChangedPrices.vue?vue&type=script&lang=ts"
import style0 from "./ChangedPrices.vue?vue&type=style&index=0&id=720995ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720995ee",
  null
  
)

export default component.exports